/**
 * Сервер отдаёт строку на плечо, а оператору нужен партнёр целиком: иначе одна
 * организация растягивается на четыре строки, и «включено» приходится читать
 * по каждой отдельно.
 *
 * Вынесено из компонента, чтобы правило проверялось тестом, не поднимая экран.
 */
export const groupByOrg = (list, sets = []) => {
    const byOrg = new Map();
    const emptyOrg = (orgId, companyName) => ({
        orgId,
        companyName,
        trustRequestPercent: false,
        active: false,
        miles: {},
        tariffSetId: null,
        tariffSetActive: false,
    });

    // Ручка отдаёт правила всех субъектов: клиентские строки правятся в карточке
    // клиента, и на экране партнёров им делать нечего — org_id у них пуст, и
    // строка склеилась бы в несуществующую организацию.
    const partnerRows = (list ?? [])
        .filter((row) => (row.subjectType ?? "ORGANIZATION") === "ORGANIZATION");

    partnerRows.forEach((row) => {
        const org = byOrg.get(row.orgId) ?? emptyOrg(row.orgId, row.companyName);
        org.companyName = org.companyName ?? row.companyName;
        // Признаки принадлежат организации: строки заводятся вместе, но
        // рассинхрон в базе возможен, и включённой считается включённая где угодно.
        org.trustRequestPercent = org.trustRequestPercent || Boolean(row.trustRequestPercent);
        org.active = org.active || Boolean(row.active);
        if (row.mileType) {
            org.miles[row.mileType] = { percent: row.percent ?? null, tariffPlanId: row.tariffPlanId ?? null };
        }
        byOrg.set(row.orgId, org);
    });

    // Комплект тарифных карт (расчёт v2) — отдельный список: он назначается
    // партнёру целиком, а не по плечам. Партнёр только с комплектом, без
    // строк скидок, тоже должен попасть в таблицу.
    (sets ?? [])
        .filter((set) => (set.subjectType ?? "ORGANIZATION") === "ORGANIZATION")
        .forEach((set) => {
            const org = byOrg.get(set.orgId) ?? emptyOrg(set.orgId, set.companyName);
            org.companyName = org.companyName ?? set.companyName;
            org.tariffSetId = set.tariffPlanId ?? null;
            org.tariffSetActive = Boolean(set.active);
            org.active = org.active || Boolean(set.active);
            byOrg.set(set.orgId, org);
        });

    return Array.from(byOrg.values())
        .sort((a, b) => (a.companyName ?? "").localeCompare(b.companyName ?? "", "ru"));
};
